import React, { useEffect, useState } from "react";
import axios from "axios";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Heart-shaped wishlist toggle for a product.
 * When guest → redirects to /connexion.
 */
const WishlistButton = ({ productId, className = "", size = 20 }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [inList, setInList] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/customers/wishlist`, { withCredentials: true });
        setInList((data || []).some((p) => p.id === productId));
      } catch {
        /* noop */
      }
    })();
  }, [user, productId]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;
    if (!user) {
      toast.info("Connectez-vous pour créer votre wishlist");
      navigate("/connexion", { state: { from: window.location.pathname } });
      return;
    }
    setBusy(true);
    try {
      if (inList) {
        await axios.delete(`${API}/customers/wishlist/${productId}`, { withCredentials: true });
        setInList(false);
        toast.success("Retiré de la wishlist");
      } else {
        await axios.post(`${API}/customers/wishlist`, { product_id: productId }, { withCredentials: true });
        setInList(true);
        toast.success("Ajouté à la wishlist");
      }
    } catch {
      toast.error("Action impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid={`wishlist-toggle-${productId}`}
      onClick={toggle}
      disabled={busy}
      aria-label={inList ? "Retirer de la wishlist" : "Ajouter à la wishlist"}
      className={`transition-colors ${inList ? "text-[color:var(--gold)]" : "text-white/60 hover:text-[color:var(--gold)]"} ${className}`}
    >
      <Heart size={size} strokeWidth={1.5} fill={inList ? "currentColor" : "none"} />
    </button>
  );
};

export default WishlistButton;
